import React, { forwardRef } from 'react';
import { useLanguage } from './LanguageProvider';
import styles from "./QuestionBackButton.module.scss";

const QuestionBackButton = ({ loading, ...props }, ref) => {
  const language = useLanguage();
  const backText = language === 'nl' ? '<' : '<';

  return (
    <button
      type="submit"
      id="previous"
      className={`${styles.backButton} button is-light is-medium is-fullwidth${loading ? ' is-loading' : ''}`}
      ref={ref}
      {...props}
    >
      {backText}
    </button>
  );
};

export default forwardRef(QuestionBackButton);
